import styled from 'styled-components';

export const StyledSpan = styled.span<{
  marginRight: string;
}>`
  margin-right: ${({ theme, marginRight }) =>
    marginRight === 'none' ? 0 : theme[`spacing_${marginRight}`]};
`;
